import { render } from "./EditPromotionTextsModal.vue?vue&type=template&id=31e75d60&scoped=true"
import script from "./EditPromotionTextsModal.vue?vue&type=script&lang=js"
export * from "./EditPromotionTextsModal.vue?vue&type=script&lang=js"

import "./EditPromotionTextsModal.vue?vue&type=style&index=0&id=31e75d60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e75d60"]])

export default __exports__